import createCachedSelector from 're-reselect'
import { selectProduct } from './selectProduct'
import { selectPlansByProduct } from './selectPlansByProduct'

export const selectAvailablePlansByProduct = createCachedSelector(
  selectPlansByProduct,
  selectProduct,
  (plans, product) => {
    return plans.filter(p => p.active || p.planId === product.plan)
  }
)((_state, product) => product || 'unknown')
